export default __webpack_public_path__ + "static/media/notpay3month.30014b02.svg";